import axios from "axios";
import Cookies from "js-cookie";
import QueryString from "query-string";
import React, { PureComponent } from "react";

import { BFF_BASE_URL } from "../../../../constants";
import { Redirect } from "../../../common/components";

/**
 * @typedef {Object} AuthState
 * @property {String} auth_destination - URL for session_token to be posted to
 * @property {String} destination - URL to redirect to
 */

class SignOut extends PureComponent {
  static redirect(target) {
    return (<Redirect url={target} />);
  }

  constructor(props) {
    super(props);

    this.state = { requestCompleted: false };
  }

  async componentDidMount() {
    await this._signout();
  }

  /**
   * Gets and decodes state from url parameters
   * @returns {AuthState}
   */
  get authState() {
    const { state } = QueryString.parse(this.props.location.search);
    return JSON.parse(atob(state || {}));
  }

  /**
   * Target destination to be redirected to after sign out
   */
  get destination() {
    const defaultDestination = "/";
    return this.authState.destination || defaultDestination;
  }

  /**
   * Performs sign out request
   */
  async _signout() {
    await axios({
      method: "post",
      url: `${BFF_BASE_URL}/signout`,
      headers: {
        Authorization: `Bearer ${Cookies.get("session_token")}`,
      },
    });
    this.setState({ requestCompleted: true });
  }

  render() {
    if (!this.state.requestCompleted) {
      return null;
    }

    return this.constructor.redirect(this.destination);
  }
}

export default SignOut;
